'use strict'
import { request } from '../../plugins/http'

export default async (data) => {
    return await request.delete('/cliente', {params:{clientId:data.ID, personId:data.PESSOA_ID}})
}